import React, { useContext } from 'react'
import classNames from 'classnames'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import ColorMultiImages from 'app/React/Components/Main/ColorMultiImages'

const ColorImageWrapper = ({ children, currentStep, currentVariant }) => {
  if (
    currentStep == 5 ||
    typeof currentVariant.campaign_image_info === 'undefined' ||
    currentVariant.campaign_image_info === null
  ) {
    return children
  }

  return (
    <div className='campaign-image-container'>
      <img
        className={'campaign-image campaign-image--placement-' + currentVariant.campaign_image_info.placement}
        alt={currentVariant.campaign_image_info.name}
        src={currentVariant.campaign_image_info.image_url}
        data-object-fit='true'
        title={currentVariant.campaign_image_info.name}
      />

      {children}
    </div>
  )
}

export default function ColorImage({ children }) {
  const {
    colorImage,
    currentVariant,
    isDealerConfigurator,
    currentStep
  } = useContext(ConfiguratorContext)

  if (typeof colorImage === 'undefined' || colorImage === null) {
    return children
  }

  // Add fallback for color_image_urls
  if (typeof colorImage.color_image_urls === 'undefined' || colorImage.color_image_urls === null) {
    return children
  }

  if (colorImage.color_image_urls.length <= 1 || currentStep == 5) {
    return (
      <div className={classNames('image-container', {
        'has-no-footer': isDealerConfigurator
      })}
      >
        <ColorImageWrapper
          currentStep={currentStep}
          currentVariant={currentVariant}
        >
          <img
            alt={colorImage.name}
            src={colorImage.color_image_urls[0]}
            data-object-fit='true'
            title={colorImage.name}
          />
        </ColorImageWrapper>
      </div>
    )
  }

  return (
    <div className={classNames('image-container', {
      'has-no-footer': isDealerConfigurator
    })}
    >
      <ColorImageWrapper
        currentStep={currentStep}
        currentVariant={currentVariant}
      >
        <ColorMultiImages
          colorImageUrls={colorImage.color_image_urls}
          title={colorImage.name}
        />
      </ColorImageWrapper>
    </div>
  )
}
